import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "../components/Nav";
import { useAuth } from "../context/AuthContext";
import { CheckCircle } from "@phosphor-icons/react";

export default function CardholderRegister() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) return setError("Password must be at least 6 characters");
    setSubmitting(true);
    const email = form.email.trim().toLowerCase();
    const res = await register({
      name: form.name.trim(),
      email,
      phone: form.phone.trim(),
      password: form.password,
    });
    setSubmitting(false);
    if (!res.ok) return setError(res.error);
    nav(`/check-email?email=${encodeURIComponent(email)}`);
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-[color:var(--cc-bg-2)]">
        <div className="max-w-md mx-auto px-4 py-12 sm:py-16">
          <div className="label-tag text-neutral-500">Cardholder</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mt-1">Create your account</h1>
          <p className="mt-2 text-sm text-neutral-700">
            Sign up now — we'll email you a verification link before you can sign in.
          </p>
          <form onSubmit={submit} className="mt-8 space-y-4 bg-white border border-black p-6" data-testid="cardholder-register-form">
            <div>
              <label className="label-tag">Full name</label>
              <input className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="ch-reg-name" required />
            </div>
            <div>
              <label className="label-tag">Email</label>
              <input type="email" className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="ch-reg-email" required />
            </div>
            <div>
              <label className="label-tag">Phone</label>
              <input className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="ch-reg-phone" placeholder="0821234567" required />
            </div>
            <div>
              <label className="label-tag">Password</label>
              <input type="password" className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="ch-reg-password" required />
            </div>
            {error && <div className="label-tag text-red-600" data-testid="ch-reg-error">{error}</div>}
            <button type="submit" disabled={submitting} className="w-full bg-black text-white label-tag px-4 py-4 brutal-btn flex items-center justify-center gap-2 disabled:opacity-60" data-testid="ch-reg-submit">
              <CheckCircle size={16} weight="bold" /> {submitting ? "Creating…" : "Create account"}
            </button>
            <div className="text-sm text-center">
              Already have an account?{" "}
              <Link to="/cardholder/login" className="label-tag underline" data-testid="ch-reg-login-link">Log in</Link>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
